import React, { useEffect } from "react";
import { useFormikContext } from "formik";
import { FormikFormGroup } from "components/common";
const DEFAULT_SPOOL_DIRECTORY = "/tmp/graylog-archive-spool";
const ArchiveBackendGCSFieldGroup = ({ enableSpool = true }) => {
  const {
    values: { id },
    setFieldValue
  } = useFormikContext();
  useEffect(() => {
    if (!id) {
      if (enableSpool) {
        setFieldValue("settings.spool_directory", DEFAULT_SPOOL_DIRECTORY);
      }
      setFieldValue("settings.output_path", "");
    }
  }, [enableSpool, setFieldValue, id]);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.bucket",
      type: "text",
      label: "GCS Bucket",
      help: "The name of your Google Cloud Storage bucket (must be globally unique).",
      labelClassName: "",
      wrapperClassName: ""
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.project_id",
      type: "text",
      label: "Project ID (optional)",
      help: "Your Google Cloud project\u2019s unique identifier.",
      labelClassName: "",
      wrapperClassName: ""
    }
  ), /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.endpoint_uri",
      type: "text",
      label: "Endpoint URI (optional)",
      help: "Optional custom endpoint for accessing the storage (leave blank for default).",
      labelClassName: "",
      wrapperClassName: ""
    }
  ), enableSpool && /* @__PURE__ */ React.createElement(
    FormikFormGroup,
    {
      name: "settings.spool_directory",
      type: "text",
      label: "Spool directory",
      help: "Spool directory for this backend.",
      labelClassName: "",
      required: true,
      wrapperClassName: ""
    }
  ));
};
export default ArchiveBackendGCSFieldGroup;
